import React from 'react';
import { Node } from '@uncinc/react-drupal-core';

import {
  PagerPrevNext,
} from '../../../components';

import './style.scss';

const MemberOverview = ({ onLoadMore, pager, loading, entities, setCurrentPage, ...props }) => {
  const currentPage = pager.get('current_page');
  const totalPages = pager.get('total_pages');

  return (
    <div className="View MembersAllOverview">
      <div className="row no-gutters">
        {entities.map((entity, index) => {
          const id = entity.getIn(['nid', '0', 'value']);
          const uuid = entity.getIn(['uuid', 0, 'value']);
          const langcode = entity.getIn(['langcode', 0, 'value']);
          const className = 'col-12 col-md-4 MembersAllOverview__item-wrapper';

          return (
            <div key={`${uuid}:${langcode}`} className={className}>
              <Node
                id={id}
                isActivePath
                entity={entity}
                viewMode="teaser"
              />
            </div>
          );
        })}
      </div>
      <PagerPrevNext currentPage={currentPage} totalPages={totalPages} setCurrentPage={setCurrentPage} />
    </div>
  );
};

export default MemberOverview;
